import { TourbookListing } from '@root/types';
import { useTranslation } from 'react-i18next';
import s from './ReorderListingCard.module.less';

type Props = {
  listing: TourbookListing;
  onHover: () => void;
  onHoverExit: () => void;
};

// eslint-disable-next-line react/jsx-no-literals
const Separator = () => <span className={s.separator}>|</span>;

export default function ReorderListingCard({ listing, onHover, onHoverExit }: Props) {
  const firstPhotosSrc = listing.photos[0]?.smallPath;
  const firstPhotosDescription = listing.photos[0]?.description;
  const { t } = useTranslation('country');

  const { displayAddress, neighborhood, cityLocalityRegion, countryCode } = listing.building;

  return (
    <article
      data-testid={`reorderListingCard-${listing.id}`}
      className={s.container}
      onMouseEnter={onHover}
      onMouseLeave={onHoverExit}
    >
      <figure className={s.photoContainer}>
        <img src={firstPhotosSrc} alt={firstPhotosDescription} />
      </figure>
      <section className={s.textSection}>
        <div className={s.buildingName}>{listing.building.primaryName}</div>
        <div className={s.listingName}>
          {displayAddress && (
            <>
              <span>{displayAddress}</span>
              <Separator />
            </>
          )}
          {listing.name && (
            <>
              <span>{listing.name}</span>
              <span className={s.desktopTabletOnly}>
                <Separator />
              </span>
            </>
          )}
          <span className={s.desktopTabletOnly}>
            {neighborhood && (
              <>
                <span>{neighborhood}</span>
                <Separator />
              </>
            )}
            <span>{cityLocalityRegion}</span>
            <Separator />
            {t(`${countryCode}`)}
          </span>
        </div>
      </section>
    </article>
  );
}
